import { render, staticRenderFns } from "./TramosRutas.vue?vue&type=template&id=5073c908"
import script from "./TramosRutas.vue?vue&type=script&lang=js"
export * from "./TramosRutas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports